import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {Cobranzas} from "./cobranzas/cobranzas";
import {MainContext} from "contexts/main.context";

const basePath = '/aprobaciones/rendiciones';

export class Rendiciones extends Component {
    render() {
        return (
            <>
                <Switch>
                    <Route path={`${basePath}/cobranza`} render={(routeProps) => <Cobranzas key={1} {...routeProps}/>}/>
                </Switch>
            </>
        )
    }
}

Rendiciones.contextType = MainContext;
